const FinancingData = () => [
    {
      id: 1,
      title: "Title 1",
      icon: "PlayArrowSharpIcon",
      subCategories: [
        {
          id: 3,
          title: "Subcategory 1",
          icon: "FiberManualRecordIcon",
        },
        {
          id: 4,
          title: "Subcategory 2",
          icon: "FiberManualRecordIcon",
        },
      ],
    },
    {
      id: 2,
      title: "Title 2",
      icon: "FiberManualRecordIcon",
    },
  ];
  
  export default FinancingData;
  